import React, { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Statistics } from "@/components/site/Statistics";
import { Products } from "@/components/site/Products";
import { CupCustomizer } from "@/components/site/CupCustomizer";
import { Manufacturing } from "@/components/site/Manufacturing";
import { Sustainability } from "@/components/site/Sustainability";
import { Industries } from "@/components/site/Industries";
import { Testimonials } from "@/components/site/Testimonials";
import { Gallery } from "@/components/site/Gallery";
import { CTABanner } from "@/components/site/CTABanner";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";
import { QuoteDialog } from "@/components/site/QuoteDialog";

export default function Home() {
  const [dialog, setDialog] = useState({ open: false, mode: "quote" });

  const openQuote = () => setDialog({ open: true, mode: "quote" });
  const openSample = () => setDialog({ open: true, mode: "sample" });
  const openConsult = () => setDialog({ open: true, mode: "consult" });
  const close = () => setDialog((d) => ({ ...d, open: false }));

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Navbar onQuote={openQuote} />
      <Hero onQuote={openQuote} onExplore={() => scrollTo("products")} />
      <About />
      <WhyChooseUs />
      <Statistics />
      <Products onQuote={openQuote} onCustomize={() => scrollTo("customize")} />
      <CupCustomizer />
      <Manufacturing />
      <Sustainability />
      <Industries />
      <Testimonials />
      <Gallery />
      <CTABanner onConsult={openConsult} onSample={openSample} />
      <Footer />
      <WhatsAppFab />
      <QuoteDialog open={dialog.open} mode={dialog.mode} onClose={close} />
    </div>
  );
}
